import { Component, OnInit, Inject } from '@angular/core';
import { MatTableDataSource, MAT_DIALOG_DATA, MatDialogRef, MatSnackBar } from '@angular/material';
import { CreateTipologiaComponent } from '../create-tipologia/create-tipologia.component';
import { Handle } from 'src/app/handle';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { GatewayService } from 'src/app/gateway.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-asignar-campana',
  templateUrl: './asignar-campana.component.html',
  styleUrls: ['./asignar-campana.component.scss']
})
export class AsignarCampanaComponent implements OnInit {

  //displayedColumns = ['CAMPANA', 'REGISTROS', 'CONTACTO', 'EFECTIVIDAD', 'CONVERSION', 'BORRAR'];
  displayedColumns = ['CAMPANA', 'CONTACTO', 'EFECTIVIDAD', 'CONVERSION', 'BORRAR'];
  table = [];
  dataSource = new MatTableDataSource<any>([]);
  FILTER; resultsLength = 0;
  campanas = [];
  idpais;

  constructor(
    private spinner: NgxSpinnerService,
    private snackbar: MatSnackBar,
    private gateway: GatewayService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<CreateTipologiaComponent>, public Handle: Handle) { }

  ngOnInit() {
    this.idpais = this.data.agente.idpais;
    this.getCampanas();
  }

  getCampanas() {
    this.gateway.get('listacampanas', { NUM_PAGINA: 0, FILTRO: this.FILTER, NUM_ELEMENTOS: 5, IDPAIS: this.idpais }).then((result) => {

       let aux:any=result;
      this.campanas = aux.rows;
      this.gateway.get('campanasagente', { IDAGENTE: this.data.agente.idagente }).then((result) => {
         let aux2:any = result;
        this.table = aux2.rows;
        this.table.forEach(element => {
          element.campana = this.campanas.find((mini) => {
            return mini.idcampana == element.idcampana;
          })
        });
        this.dataSource = new MatTableDataSource<any>(this.table);
      }
      ).catch(function (e) {
      });
    }
    ).catch(function (e) {
    });
  }

  asignar() {
    this.spinner.show();
    let ASG = {
      IDAGENTE: this.data.agente.idagente, LISTA: this.table
    }
    this.gateway.save('asignarcampana', ASG).then((result) => {
      this.spinner.hide();
      this.snackbar.open('Datos almacenados con éxito.', 'Cerrar', {duration: 3000,});
      this.dialogRef.close();
    }).catch(function (e) {
    });

  }

  addCampana() {
    let campana = {
      campana: this.grupoVal.controls.CAMPANA.value,
      registros: 0,
      contacto: this.grupoVal.controls.CONTACTO.value,
      efectividad: this.grupoVal.controls.EFECTIVIDAD.value,
      conversion: this.grupoVal.controls.CONVERSION.value
    }
    // console.log(this.table.find(element => { return element.CAMPANA.IDCAMPANA == campana.CAMPANA.IDCAMPANA }))

    if (this.table.find(element => { return element.campana.idcampana == campana.campana.idcampana })) {
      this.snackbar.open('Ya tiene asignada la campaña', '', {
        duration: 3000,
      });
      return;
    } else {
      this.table.push(campana);
      // console.log(this.table);

      this.dataSource = new MatTableDataSource<any>(this.table);
    }

  }

  onNoClick() {
    this.dialogRef.close();
  }

  delete(element) {
    //console.log(element);
    let auxind = -1;
    auxind = this.table.indexOf(element);
    this.table.splice(auxind, 1)
    this.dataSource = new MatTableDataSource(this.table);
  }

  grupoVal = new FormGroup({
    CAMPANA: new FormControl('', [Validators.compose([
      Validators.required
    ])]),
    CONTACTO: new FormControl('', Validators.compose([
      Validators.required, Validators.min(1), Validators.max(100)
    ])),
    EFECTIVIDAD: new FormControl('', Validators.compose([
      Validators.required, Validators.min(1), Validators.max(100)
    ])),
    CONVERSION: new FormControl('', Validators.compose([
      Validators.required, Validators.min(1), Validators.max(100)
    ])),
  });

}

const SAMPLE2: any[] = [
  { CAMPANA: 'SUB 1', REGISTROS: 10, CONTACTO: 10, EFECTIVIDAD: 20, CONVERSION: 30 },
  { CAMPANA: 'SUB 2', REGISTROS: 20, CONTACTO: 10, EFECTIVIDAD: 20, CONVERSION: 30 },
  { CAMPANA: 'SUB 3', REGISTROS: 30, CONTACTO: 10, EFECTIVIDAD: 20, CONVERSION: 30 },
  { CAMPANA: 'SUB 4', REGISTROS: 40, CONTACTO: 10, EFECTIVIDAD: 20, CONVERSION: 30 },
];
